 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"attendance-clock-record":"attendance-clock-record","attendance-clock-stats~shift-manage":"attendance-clock-stats~shift-manage","attendance-clock-stats":"attendance-clock-stats","shift-manage":"shift-manage","autidt-list":"autidt-list","carousel-list~link-list~menu-list~permissions-list":"carousel-list~link-list~menu-list~permissions-list","menu-list":"menu-list","permissions-list":"permissions-list","position-list":"position-list","individual-list":"individual-list","user-list":"user-list","bill-edit":"bill-edit","customer-view":"customer-view","individual-view":"individual-view","manage-members":"manage-members","ad-position-list":"ad-position-list","article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":"article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit","article-edit":"article-edit","company-edit":"company-edit","openapiServer-edit":"openapiServer-edit","settlement-edit":"settlement-edit","article-list":"article-list","attachment-list":"attachment-list","autidt-bill~autidt-contract~autidt-view~daily-settlement":"autidt-bill~autidt-contract~autidt-view~daily-settlement","autidt-view":"autidt-view","carousel-list":"carousel-list","link-list":"link-list","company-list":"company-list","lecturer-list":"lecturer-list","autidt-bill":"autidt-bill","autidt-contract":"autidt-contract","daily-settlement":"daily-settlement","article-create":"article-create","bill-list":"bill-list","common-list":"common-list","customer-list":"customer-list","roles-list":"roles-list","task-list":"task-list","openapiServer-list":"openapiServer-list","settlement-list":"settlement-list","sys_log-list~withdraw-list":"sys_log-list~withdraw-list","sys_log-list":"sys_log-list","withdraw-list":"withdraw-list","tax-list":"tax-list","ws_account":"ws_account","category-list":"category-list","live-list":"live-list","setting-site":"setting-site","everyday_statistics":"everyday_statistics","exception-404":"exception-404","login":"login","new_hr":"new_hr","register":"register","setting-base":"setting-base","statistics-flow~statistics-region":"statistics-flow~statistics-region","statistics-flow":"statistics-flow","statistics-region":"statistics-region","statistics-list":"statistics-list","token-login":"token-login"}[chunkId]||chunkId) + "." + {"attendance-clock-record":"e4abd171","attendance-clock-stats~shift-manage":"799e41ca","attendance-clock-stats":"a628acb2","shift-manage":"c2d5d9e9","autidt-list":"70225426","carousel-list~link-list~menu-list~permissions-list":"c4b5a333","menu-list":"28e80000","permissions-list":"e286e07a","chunk-05dd824a":"3292d090","chunk-2e0f34bd":"19fbd96b","chunk-689139d2":"57bbba80","chunk-73be8d41":"aa7b6af2","position-list":"647ec140","chunk-7bc477e4":"4e61cd9d","individual-list":"fa0b8a1d","user-list":"be82733d","chunk-3108329c":"0feebea5","chunk-325098ac":"69debd8d","chunk-59f10238":"b3981149","chunk-6e83591c":"163e5349","chunk-34182fda":"ea39283e","chunk-c442ea18":"7b8881b1","bill-edit":"843d523b","chunk-392798fa":"7fd242c5","chunk-119d2fd9":"2e519840","customer-view":"7fea8d1b","individual-view":"51a5c3d2","manage-members":"d55bb4d8","chunk-5ccfe9ff":"9c6d1dd1","chunk-1c8840f0":"efdd76ce","chunk-2d80da10":"f9466e03","chunk-2b3e2cfe":"b80670af","chunk-78c4cfe8":"b0e2767e","chunk-26dada40":"10fd6496","chunk-37930f86":"afddaece","chunk-9e9c9b90":"5c5cdf13","ad-position-list":"358dd93e","article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":"cf6bdc6c","article-edit":"4905acef","company-edit":"b187f813","openapiServer-edit":"1291d4f0","settlement-edit":"d8ea1352","article-list":"3b4db3ef","attachment-list":"962b0e0d","autidt-bill~autidt-contract~autidt-view~daily-settlement":"3c57092b","autidt-view":"90000d25","carousel-list":"ad2dc741","link-list":"b5bb9c67","company-list":"14d98653","lecturer-list":"455e0233","autidt-bill":"67b366bf","autidt-contract":"f1c08f6a","daily-settlement":"116c9772","chunk-4e000596":"bed75db7","article-create":"722b2d21","bill-list":"172e6cf7","common-list":"53f5fabc","customer-list":"a739f972","roles-list":"9af5ae1d","task-list":"67643227","openapiServer-list":"703c5032","settlement-list":"a6cdd4e5","sys_log-list~withdraw-list":"3e93279c","sys_log-list":"890da85f","withdraw-list":"32e93fab","tax-list":"4331d315","ws_account":"384fc0c2","category-list":"5e9a6fe1","live-list":"3f70f80c","setting-site":"9db047b8","chunk-ccbb65ca":"afa52040","chunk-fdf9545a":"225c5d06","everyday_statistics":"acaa8f8b","exception-404":"5e303160","login":"458993e3","new_hr":"59bd1539","register":"498b6dad","setting-base":"a9cc57fa","statistics-flow~statistics-region":"c6494b83","statistics-flow":"f3e977b1","statistics-region":"b3e202dc","statistics-list":"0e3058c0","token-login":"984b6b76","chunk-a15b667e":"a72532e1","chunk-2d225891":"394a0912"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"attendance-clock-record":1,"attendance-clock-stats~shift-manage":1,"attendance-clock-stats":1,"shift-manage":1,"autidt-list":1,"carousel-list~link-list~menu-list~permissions-list":1,"menu-list":1,"permissions-list":1,"chunk-05dd824a":1,"chunk-2e0f34bd":1,"chunk-689139d2":1,"position-list":1,"chunk-7bc477e4":1,"individual-list":1,"user-list":1,"chunk-3108329c":1,"chunk-325098ac":1,"chunk-59f10238":1,"chunk-c442ea18":1,"bill-edit":1,"chunk-392798fa":1,"chunk-119d2fd9":1,"customer-view":1,"individual-view":1,"manage-members":1,"chunk-5ccfe9ff":1,"chunk-1c8840f0":1,"chunk-2d80da10":1,"chunk-2b3e2cfe":1,"chunk-78c4cfe8":1,"chunk-26dada40":1,"chunk-37930f86":1,"ad-position-list":1,"article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":1,"article-edit":1,"company-edit":1,"openapiServer-edit":1,"settlement-edit":1,"article-list":1,"attachment-list":1,"autidt-bill~autidt-contract~autidt-view~daily-settlement":1,"autidt-view":1,"carousel-list":1,"link-list":1,"company-list":1,"lecturer-list":1,"autidt-bill":1,"autidt-contract":1,"daily-settlement":1,"chunk-4e000596":1,"article-create":1,"bill-list":1,"common-list":1,"customer-list":1,"roles-list":1,"task-list":1,"openapiServer-list":1,"settlement-list":1,"sys_log-list~withdraw-list":1,"sys_log-list":1,"withdraw-list":1,"tax-list":1,"ws_account":1,"category-list":1,"live-list":1,"setting-site":1,"chunk-ccbb65ca":1,"chunk-fdf9545a":1,"everyday_statistics":1,"exception-404":1,"login":1,"new_hr":1,"register":1,"setting-base":1,"statistics-flow":1,"statistics-region":1,"statistics-list":1,"token-login":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"attendance-clock-record":"attendance-clock-record","attendance-clock-stats~shift-manage":"attendance-clock-stats~shift-manage","attendance-clock-stats":"attendance-clock-stats","shift-manage":"shift-manage","autidt-list":"autidt-list","carousel-list~link-list~menu-list~permissions-list":"carousel-list~link-list~menu-list~permissions-list","menu-list":"menu-list","permissions-list":"permissions-list","position-list":"position-list","individual-list":"individual-list","user-list":"user-list","bill-edit":"bill-edit","customer-view":"customer-view","individual-view":"individual-view","manage-members":"manage-members","ad-position-list":"ad-position-list","article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":"article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit","article-edit":"article-edit","company-edit":"company-edit","openapiServer-edit":"openapiServer-edit","settlement-edit":"settlement-edit","article-list":"article-list","attachment-list":"attachment-list","autidt-bill~autidt-contract~autidt-view~daily-settlement":"autidt-bill~autidt-contract~autidt-view~daily-settlement","autidt-view":"autidt-view","carousel-list":"carousel-list","link-list":"link-list","company-list":"company-list","lecturer-list":"lecturer-list","autidt-bill":"autidt-bill","autidt-contract":"autidt-contract","daily-settlement":"daily-settlement","article-create":"article-create","bill-list":"bill-list","common-list":"common-list","customer-list":"customer-list","roles-list":"roles-list","task-list":"task-list","openapiServer-list":"openapiServer-list","settlement-list":"settlement-list","sys_log-list~withdraw-list":"sys_log-list~withdraw-list","sys_log-list":"sys_log-list","withdraw-list":"withdraw-list","tax-list":"tax-list","ws_account":"ws_account","category-list":"category-list","live-list":"live-list","setting-site":"setting-site","everyday_statistics":"everyday_statistics","exception-404":"exception-404","login":"login","new_hr":"new_hr","register":"register","setting-base":"setting-base","statistics-flow~statistics-region":"statistics-flow~statistics-region","statistics-flow":"statistics-flow","statistics-region":"statistics-region","statistics-list":"statistics-list","token-login":"token-login"}[chunkId]||chunkId) + "." + {"attendance-clock-record":"8924ce90","attendance-clock-stats~shift-manage":"6fdfe8be","attendance-clock-stats":"b1e375a0","shift-manage":"baffa913","autidt-list":"f1cf9de3","carousel-list~link-list~menu-list~permissions-list":"f1cf9de3","menu-list":"8bc0eb7c","permissions-list":"b9c9ddca","chunk-05dd824a":"41f49f96","chunk-2e0f34bd":"151fb899","chunk-689139d2":"8aa71e8a","chunk-73be8d41":"31d6cfe0","position-list":"8c8b504f","chunk-7bc477e4":"f6005c5c","individual-list":"ca7875e5","user-list":"0fbd0d20","chunk-3108329c":"f487520e","chunk-325098ac":"f47a419e","chunk-59f10238":"a1e9056b","chunk-6e83591c":"31d6cfe0","chunk-34182fda":"31d6cfe0","chunk-c442ea18":"db5c6c4e","bill-edit":"127772d2","chunk-392798fa":"92464486","chunk-119d2fd9":"59d188eb","customer-view":"c5a55abb","individual-view":"6f914dec","manage-members":"14704666","chunk-5ccfe9ff":"dbbaae3d","chunk-1c8840f0":"44798df4","chunk-2d80da10":"07e65ce0","chunk-2b3e2cfe":"2a50113c","chunk-78c4cfe8":"0f8b4c06","chunk-26dada40":"2b873ffa","chunk-37930f86":"60921343","chunk-9e9c9b90":"31d6cfe0","ad-position-list":"6c15f24d","article-edit~company-edit~company-list~lecturer-list~openapiServer-edit~settlement-edit":"fcca00d1","article-edit":"81c2326f","company-edit":"6a772072","openapiServer-edit":"372bfbde","settlement-edit":"9f445d30","article-list":"fc157c4b","attachment-list":"14bd5e7b","autidt-bill~autidt-contract~autidt-view~daily-settlement":"befd2898","autidt-view":"a7887fef","carousel-list":"5332e5a6","link-list":"bf53ea62","company-list":"e0d49afd","lecturer-list":"886cab67","autidt-bill":"5f186058","autidt-contract":"f15e237e","daily-settlement":"9419698f","chunk-4e000596":"f3579bd2","article-create":"7c0c27a6","bill-list":"bacca06c","common-list":"18a54ca1","customer-list":"84fe8479","roles-list":"e30af8ba","task-list":"9e4bb863","openapiServer-list":"ff12898c","settlement-list":"a1529f2c","sys_log-list~withdraw-list":"2513fa6f","sys_log-list":"a823e037","withdraw-list":"c2e02f20","tax-list":"ad4ccbf6","ws_account":"98eb842a","category-list":"65c3310f","live-list":"a512e19f","setting-site":"edb73df0","chunk-ccbb65ca":"df2f2f8d","chunk-fdf9545a":"614c7561","everyday_statistics":"508ea32f","exception-404":"604eae9b","login":"57d1f132","new_hr":"3434eff9","register":"a516e40b","setting-base":"f1cf9de3","statistics-flow~statistics-region":"31d6cfe0","statistics-flow":"40a66952","statistics-region":"112f20a9","statistics-list":"f1cf9de3","token-login":"4efaaed6","chunk-a15b667e":"31d6cfe0","chunk-2d225891":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
